import { Calendar } from 'lucide-react';
import { useTheme } from './ThemeContext';

export default function DatePicker({ 
  value, 
  onChange, 
  min, 
  max, 
  label, 
  placeholder,
  required = false,
  style = {}
}) {
  const { colors } = useTheme();

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column', 
      gap: '0.5rem',
      ...style 
    }}>
      {label && (
        <label style={{
          color: colors.text,
          fontWeight: 'bold',
          fontSize: '0.95rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem'
        }}>
          <Calendar size={18} />
          {label}
          {required && <span style={{ color: colors.accent }}>*</span>}
        </label>
      )}
      
      <div style={{ position: 'relative' }}>
        <input
          type="date"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          min={min}
          max={max}
          placeholder={placeholder}
          required={required}
          style={{
            width: '100%',
            padding: '0.875rem',
            paddingRight: '2.5rem',
            background: colors.bgInput,
            border: `1px solid ${colors.border}`,
            borderRadius: '8px',
            color: colors.text,
            fontSize: '1rem',
            outline: 'none',
            cursor: 'pointer',
            transition: 'all 0.2s',
            // Style the calendar icon
            colorScheme: 'dark'
          }}
          onFocus={(e) => {
            e.currentTarget.style.borderColor = colors.accent;
            e.currentTarget.style.background = colors.bgCard;
          }}
          onBlur={(e) => {
            e.currentTarget.style.borderColor = colors.border;
            e.currentTarget.style.background = colors.bgInput;
          }}
        />
      </div>
      
      <style>{`
        /* Style the native date picker calendar icon */
        input[type="date"]::-webkit-calendar-picker-indicator {
          cursor: pointer;
          opacity: 0.7;
          filter: invert(1);
        }
        
        input[type="date"]::-webkit-calendar-picker-indicator:hover {
          opacity: 1;
        }
        
        /* Firefox */
        input[type="date"]::-moz-calendar-picker-indicator {
          cursor: pointer;
          opacity: 0.7;
          filter: invert(1);
        }
        
        input[type="date"]::-moz-calendar-picker-indicator:hover {
          opacity: 1;
        }
      `}</style>
    </div>
  );
}
